module.exports = new __parcel__URL__("dmg.ae4f1a79.png").toString();